// SRZC Program Variables
export const srzcVariables: any = {
    programTitle: "Schulte Roth & Zabel LLP (Counsel)",
    effectiveDates: "8/1/2020 - 8/1/2021",
    feeDisclaimer: null,
    EL_Items: [
        "SRZC_EL_Header",
        ["SRZC_EL_1M", "$1,000,000", "$1,000,000", "Paid by Firm"],
        ["SRZC_EL_2M", "$2,000,000", "$1,000,000", "$152"],
        ["SRZC_EL_3M", "$3,000,000", "$1,000,000", "$273"],
        ["SRZC_EL_5M", "$5,000,000", "$1,000,000", "$439"],
        ["SRZC_EL_10M", "$10,000,000", "$1,000,000", "$1,337"],
        ["SRZC_EL_15M", "$15,000,000*", "$1,000,000", "$2,385"],
        ["SRZC_EL_20M", "$20,000,000*", "$1,000,000", "$3,837"],
        ["SRZC_EL_25M", "$25,000,000*", "$1,000,000", "$5,149"]
    ],
    EL_Disclaimers: [
        `<strong>*</strong>A completed Chubb Group Personal Excess Participant Questionnaire is required for any participant who <u>newly elects</u> or <u>enrolls</u> at these limits along with underwriting approval.
        In addition, it is a requirement that your underlying home and automobile coverage be in place with Chubb.
        Current participants are grandfathered in at their expiring limits.`
    ],
    UM_Items: [
        "SRZC_UM_Header",
        ["SRZC_UM_1M", "$1,000,000", "Included above"],
        ["SRZC_UM_2M", "$2,000,000", "$118"],
        ["SRZC_UM_3M", "$3,000,000", "$237"],
        ["SRZC_UM_5M", "$5,000,000", "$474"]
    ],
    EPLI_Items: [
        "SRZC_EP_Header",
        ["SRZC_EP_Decline", "By selecting this box, I am declining EPLI Insurance."],
        ["SRZC_EP_250K", "$250,000 per occurrence / $500,000 aggregate*", "$10,000", "$756"],
        ["SRZC_EP_500K", "$500,000 per occurrence / $500,000 aggregate*", "$10,000", "$1,134"],
    ],
    CI_Items: [
        "SRZC_PR_Parent",
        "SRZC_PR_Yes",
        "SRZC_PR_No"
    ]
};

